const model = {
    agencyDetails: null,
    submitting: false,
    success: '',
    loading: false,
    errors: null,
};

export default model;
